import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { createNewHandbookApi } from '@/api/handbookApi'

export const TAB_TABLE_TIME_AND_LOAD_URL = 'calendar/tabs'

const errors = createHandbookResponseErrors('таб таблицы сроков и загрузки', 'табов таблицы сроков и загрузки')

export const TabTableTimeAndLoadApi = createNewHandbookApi(TAB_TABLE_TIME_AND_LOAD_URL, errors)
